import { ComponentType } from 'react';
import * as LucideIcons from 'lucide-react';

interface LucideIconProps {
  name: string;
  className?: string;
  size?: number;
  width?: number;
  height?: number;
}

// Icon name mapping to handle different naming conventions
const iconNameMap: Record<string, string> = {
  'lucide:user': 'User',
  'lucide:home': 'Home',
  'lucide:arrow-left': 'ArrowLeft',
  'lucide:arrow-right': 'ArrowRight',
  'lucide:chevron-right': 'ChevronRight',
  'lucide:chevron-left': 'ChevronLeft',
  'lucide:edit': 'Edit',
  'lucide:edit-2': 'Edit2',
  'lucide:save': 'Save',
  'lucide:x': 'X',
  'lucide:menu': 'Menu',
  'lucide:sun': 'Sun',
  'lucide:moon': 'Moon',
  'lucide:camera': 'Camera',
  'lucide:upload': 'Upload',
  'lucide:external-link': 'ExternalLink',
  'lucide:eye': 'Eye',
  'lucide:calendar': 'Calendar',
  'lucide:clock': 'Clock',
  'lucide:tag': 'Tag',
  'lucide:search': 'Search',
  'lucide:search-x': 'SearchX',
  'lucide:filter': 'Filter',
  'lucide:plus': 'Plus',
  'lucide:trash': 'Trash',
  'lucide:trash-2': 'Trash2',
  'lucide:settings': 'Settings',
  'lucide:image-plus': 'ImagePlus',
  'lucide:image': 'Image',
  'lucide:image-off': 'ImageOff',
  'lucide:image-x': 'X',
  'lucide:check-circle': 'CheckCircle',
  'lucide:loader-2': 'Loader2',
  'lucide:circle': 'Circle',
  'lucide:book-open': 'BookOpen',
  'lucide:mail': 'Mail',
  'lucide:lock': 'Lock',
  'lucide:alert-circle': 'AlertCircle',
  'lucide:alert-triangle': 'AlertTriangle',
  'lucide:code': 'Code',
  'lucide:bot': 'Bot',
  'lucide:bitcoin': 'Bitcoin',
  'lucide:copy': 'Copy',
  'lucide:log-out': 'LogOut',
  'lucide:log-in': 'LogIn',
  'lucide:layout-dashboard': 'LayoutDashboard',
  'lucide:check': 'Check',
  'lucide:bold': 'Bold',
  'lucide:italic': 'Italic',
  'lucide:strikethrough': 'Strikethrough',
  'lucide:heading-1': 'Heading1',
  'lucide:heading-2': 'Heading2',
  'lucide:heading-3': 'Heading3',
  'lucide:list': 'List',
  'lucide:list-ordered': 'ListOrdered',
  'lucide:quote': 'Quote',
  'lucide:link': 'Link',
  'lucide:undo': 'Undo',
  'lucide:redo': 'Redo',
  'lucide:bar-chart-3': 'BarChart3',
  'lucide:trophy': 'Trophy',
  'lucide:star': 'Star',
  'lucide:trending-up': 'TrendingUp',
  'lucide:file-text': 'FileText',
  'lucide:folder': 'Folder',
  'mdi:weather-sunny': 'Sun',
  'mdi:weather-night': 'Moon',
  'mdi:arrow-left': 'ArrowLeft',
  'mdi:arrow-right': 'ArrowRight',
  'mdi:close': 'X',
  'mdi:menu': 'Menu',
};

export function LucideIcon({ name, className = '', size = 20, width, height }: LucideIconProps) {
  // Get the mapped icon name or use the name directly
  const iconName = iconNameMap[name] || name;
  
  // Get the icon component from lucide-react
  const IconComponent = (LucideIcons as any)[iconName] as ComponentType<any>;
  
  if (!IconComponent) {
    // Fallback to a simple dot if icon not found
    return (
      <span 
        className={`inline-block text-center ${className}`}
        style={{ 
          width: width || size,
          height: height || size,
          lineHeight: `${height || size}px`,
          fontSize: '12px'
        }}
        title={`Icon: ${name}`}
      >
        •
      </span>
    );
  }
  
  return (
    <IconComponent 
      className={className}
      size={size}
      width={width || size}
      height={height || size}
    />
  );
}
